export const colors = [
    {label: 'noir', rgb: 'rgb(0, 0, 0)'},
    {label: 'gris foncé 4', rgb: 'rgb(67, 67, 67)'},
    {label: 'gris foncé 3', rgb: 'rgb(102, 102, 102)'},
    {label: 'gris foncé 2', rgb: 'rgb(153, 153, 153)'},
    {label: 'gris foncé 1', rgb: 'rgb(183, 183, 183)'},
    {label: 'gris', rgb: 'rgb(204, 204, 204)'},
    {label: 'gris clair 1', rgb: 'rgb(217, 217, 217)'},
    {label: 'gris clair 2', rgb: 'rgb(239, 239, 239)'},
    {label: 'gris clair 3', rgb: 'rgb(243, 243, 243)'},
    {label: 'blanc', rgb: 'rgb(255, 255, 255)'},
    {label: 'fruits rouges', rgb: 'rgb(152, 0, 0)'},
    {label: 'rouge', rgb: 'rgb(255, 0, 0)'},
    {label: 'orange', rgb: 'rgb(255, 153, 0)'},
    {label: 'jaune', rgb: 'rgb(255, 255, 0)'},
    {label: 'vert', rgb: 'rgb(0, 255, 0)'},
    {label: 'cyan', rgb: 'rgb(0, 255, 255)'},
    {label: 'bleu bleuet', rgb: 'rgb(74, 134, 232)'},
    {label: 'bleu', rgb: 'rgb(0, 0, 255)'},
    {label: 'violet', rgb: 'rgb(153, 0, 255)'},
    {label: 'magenta', rgb: 'rgb(255, 0, 255)'},
    {label: 'fruits rouge clair 3', rgb: 'rgb(230, 184, 175)'},
    {label: 'rouge clair 3', rgb: 'rgb(244, 204, 204)'},
    {label: 'orange clair 3', rgb: 'rgb(252, 229, 205)'},
    {label: 'jaune clair 3', rgb: 'rgb(255, 242, 204)'},
    {label: 'vert clair 3', rgb: 'rgb(217, 234, 211)'},
    {label: 'cyan clair 3', rgb: 'rgb(208, 224, 227)'},
    {label: 'bleu bleuet clair 3', rgb: 'rgb(201, 218, 248)'},
    {label: 'bleu clair 3', rgb: 'rgb(207, 226, 243)'},
    {label: 'violet clair 3', rgb: 'rgb(217, 210, 233)'},
    {label: 'magenta clair 3', rgb: 'rgb(234, 209, 220)'},
    {label: 'fruits rouge clair 2', rgb: 'rgb(221, 126, 107)'},
    {label: 'rouge clair 2', rgb: 'rgb(234, 153, 153)'},
    {label: 'orange clair 2', rgb: 'rgb(249, 203, 156)'},
    {label: 'jaune clair 2', rgb: 'rgb(255, 229, 153)'},
    {label: 'vert clair 2', rgb: 'rgb(182, 215, 168)'},
    {label: 'cyan clair 2', rgb: 'rgb(162, 196, 201)'},
    {label: 'bleu bleuet clair 2', rgb: 'rgb(164, 194, 244)'},
    {label: 'bleu clair 2', rgb: 'rgb(159, 197, 232)'},
    {label: 'violet clair 2', rgb: 'rgb(180, 167, 214)'},
    {label: 'magenta clair 2', rgb: 'rgb(213, 166, 189)'},
    {label: 'fruits rouge clair 1', rgb: 'rgb(204, 65, 37)'},
    {label: 'rouge clair 1', rgb: 'rgb(224, 102, 102)'},
    {label: 'orange clair 1', rgb: 'rgb(246, 178, 107)'},
    {label: 'jaune clair 1', rgb: 'rgb(255, 217, 102)'},
    {label: 'vert clair 1', rgb: 'rgb(147, 196, 125)'},
    {label: 'cyan clair 1', rgb: 'rgb(118, 165, 175)'},
    {label: 'bleu bleuet clair 1', rgb: 'rgb(109, 158, 235)'},
    {label: 'bleu clair 1', rgb: 'rgb(111, 168, 220)'},
    {label: 'violet clair 1', rgb: 'rgb(142, 124, 195)'},
    {label: 'magenta clair 1', rgb: 'rgb(194, 123, 160)'},
    {label: 'fruits rouge foncé 1', rgb: 'rgb(166, 28, 0)'},
    {label: 'rouge foncé 1', rgb: 'rgb(204, 0, 0)'},
    {label: 'orange foncé 1', rgb: 'rgb(230, 145, 56)'},
    {label: 'jaune foncé 1', rgb: 'rgb(241, 194, 50)'},
    {label: 'vert foncé 1', rgb: 'rgb(106, 168, 79)'},
    {label: 'cyan foncé 1', rgb: 'rgb(69, 129, 142)'},
    {label: 'bleu bleuet foncé 1', rgb: 'rgb(60, 120, 216)'},
    {label: 'bleu foncé 1', rgb: 'rgb(61, 133, 198)'},
    {label: 'violet foncé 1', rgb: 'rgb(103, 78, 167)'},
    {label: 'magenta foncé 1', rgb: 'rgb(166, 77, 121)'},
    {label: 'fruits rouge foncé 2', rgb: 'rgb(133, 32, 12)'},
    {label: 'rouge foncé 2', rgb: 'rgb(153, 0, 0)'},
    {label: 'orange foncé 2', rgb: 'rgb(180, 95, 6)'},
    {label: 'jaune foncé 2', rgb: 'rgb(191, 144, 0)'},
    {label: 'vert foncé 2', rgb: 'rgb(56, 118, 29)'},
    {label: 'cyan foncé 2', rgb: 'rgb(19, 79, 92)'},
    {label: 'bleu bleuet foncé 2', rgb: 'rgb(17, 85, 204)'},
    {label: 'bleu foncé 2', rgb: 'rgb(11, 83, 148)'},
    {label: 'violet foncé 2', rgb: 'rgb(53, 28, 117)'},
    {label: 'magenta foncé 2', rgb: 'rgb(116, 27, 71)'},
    {label: 'fruits rouge foncé 3', rgb: 'rgb(91, 15, 0)'},
    {label: 'rouge foncé 3', rgb: 'rgb(102, 0, 0)'},
    {label: 'orange foncé 3', rgb: 'rgb(120, 63, 4)'},
    {label: 'jaune foncé 3', rgb: 'rgb(127, 96, 0)'},
    {label: 'vert foncé 3', rgb: 'rgb(39, 78, 19)'},
    {label: 'cyan foncé 3', rgb: 'rgb(12, 52, 61)'},
    {label: 'bleu bleuet foncé 3', rgb: 'rgb(28, 69, 135)'},
    {label: 'bleu foncé 3', rgb: 'rgb(7, 55, 99)'},
    {label: 'violet foncé 3', rgb: 'rgb(32, 18, 77)'},
    {label: 'magenta foncé 3', rgb: 'rgb(76, 17, 48)'},
];
